import script from "./TasksFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./TasksFilter.vue?vue&type=script&setup=true&lang=js"

import "./TasksFilter.vue?vue&type=style&index=0&id=ed2e9e9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed2e9e9e"]])

export default __exports__